import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  DataApiResponseLegacy,
  GeneralLedgerAccountModel,
  GeneralLedgerAccountRelatedItemsModel,
} from '@digilize/shared/definitions/src';

@Injectable({ providedIn: 'root' })
export class GeneralLedgerAccountService {
  readonly GENERAL_LEDGER_URL = '/api/v1.0/general-ledger-account';

  constructor(private http: HttpClient) {}

  /* TODO: add typing */

  /* Serialises the DataTables envelope in camelCase (`recordsFiltered`), not the snake_case
     swagger documents for it — hence DataApiResponseLegacy. */
  getGeneralLedgersList(params) {
    return this.http.get<DataApiResponseLegacy<GeneralLedgerAccountModel[]>>(`${this.GENERAL_LEDGER_URL}`, { params });
  }

  addGeneralLedgerAccount(data: GeneralLedgerAccountModel) {
    return this.http.post<GeneralLedgerAccountModel>(`${this.GENERAL_LEDGER_URL}`, data);
  }

  editGeneralLedgerAccount(data: GeneralLedgerAccountModel) {
    return this.http.put<GeneralLedgerAccountModel>(`${this.GENERAL_LEDGER_URL}`, data);
  }

  getGeneralLedgerAccountDetails(id: string) {
    return this.http.get<GeneralLedgerAccountModel>(`${this.GENERAL_LEDGER_URL}/${id}`);
  }

  removeGeneralLedgerAccount(id: string) {
    return this.http.delete(`${this.GENERAL_LEDGER_URL}/${id}`);
  }

  getGeneralLedgerRelatedItems = (id: string) =>
    this.http.get<GeneralLedgerAccountRelatedItemsModel>(`${this.GENERAL_LEDGER_URL}/${id}/related-items`);
}
